/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/app.index'
import { Route as AppApprovalsRouteImport } from './routes/app.approvals'
import { Route as AppApprovedRouteImport } from './routes/app.approved'
import { Route as AppContentRouteImport } from './routes/app.content'
import { Route as AppInboxRouteImport } from './routes/app.inbox'
import { Route as AppProfileRouteImport } from './routes/app.profile'
import { Route as AppReserveRouteImport } from './routes/app.reserve'
import { Route as ApproveTokenRouteImport } from './routes/approve.$token'
import { Route as CalendarTokenRouteImport } from './routes/calendar.$token'
import { Route as LoginVerifyRouteImport } from './routes/login_.verify'
import { Route as AppAdminAiRouteImport } from './routes/app.admin.ai'
import { Route as AppAdminApiTokensRouteImport } from './routes/app.admin.api-tokens'
import { Route as AppAdminEmailsRouteImport } from './routes/app.admin.emails'
import { Route as AppAdminJobsRouteImport } from './routes/app.admin.jobs'
import { Route as AppAdminMediaVocabRouteImport } from './routes/app.admin.media-vocab'
import { Route as AppAdminUsageRouteImport } from './routes/app.admin.usage'
import { Route as AppAdminUsersRouteImport } from './routes/app.admin.users'
import { Route as AppApprovalsIndexRouteImport } from './routes/app.approvals.index'
import { Route as AppHotelsIndexRouteImport } from './routes/app.hotels.index'
import { Route as AppHotelsHotelIdRouteImport } from './routes/app.hotels.$hotelId'
import { Route as AppHotelsNewRouteImport } from './routes/app.hotels.new'
import { Route as AppPlansIndexRouteImport } from './routes/app.plans.index'
import { Route as AppPlansNewRouteImport } from './routes/app.plans.new'
import { Route as AppApprovalsBatchIdPreviewRouteImport } from './routes/app.approvals.$batchId.preview'
import { Route as AppHotelsHotelIdIndexRouteImport } from './routes/app.hotels.$hotelId.index'
import { Route as AppHotelsHotelIdActivityRouteImport } from './routes/app.hotels.$hotelId.activity'
import { Route as AppHotelsHotelIdArchiveRouteImport } from './routes/app.hotels.$hotelId.archive'
import { Route as AppHotelsHotelIdCalendarRouteImport } from './routes/app.hotels.$hotelId.calendar'
import { Route as AppHotelsHotelIdEventsRouteImport } from './routes/app.hotels.$hotelId.events'
import { Route as AppHotelsHotelIdMediaRouteImport } from './routes/app.hotels.$hotelId.media'
import { Route as AppHotelsHotelIdSettingsRouteImport } from './routes/app.hotels.$hotelId.settings'
import { Route as AppPlansHotelIdYearMonthRouteImport } from './routes/app.plans.$hotelId.$year.$month'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppApprovalsRoute = AppApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => AppRoute,
} as any)
const AppApprovedRoute = AppApprovedRouteImport.update({
  id: '/approved',
  path: '/approved',
  getParentRoute: () => AppRoute,
} as any)
const AppContentRoute = AppContentRouteImport.update({
  id: '/content',
  path: '/content',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxRoute = AppInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppReserveRoute = AppReserveRouteImport.update({
  id: '/reserve',
  path: '/reserve',
  getParentRoute: () => AppRoute,
} as any)
const ApproveTokenRoute = ApproveTokenRouteImport.update({
  id: '/approve/$token',
  path: '/approve/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarTokenRoute = CalendarTokenRouteImport.update({
  id: '/calendar/$token',
  path: '/calendar/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginVerifyRoute = LoginVerifyRouteImport.update({
  id: '/login_/verify',
  path: '/login/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAdminAiRoute = AppAdminAiRouteImport.update({
  id: '/admin/ai',
  path: '/admin/ai',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminApiTokensRoute = AppAdminApiTokensRouteImport.update({
  id: '/admin/api-tokens',
  path: '/admin/api-tokens',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminEmailsRoute = AppAdminEmailsRouteImport.update({
  id: '/admin/emails',
  path: '/admin/emails',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminJobsRoute = AppAdminJobsRouteImport.update({
  id: '/admin/jobs',
  path: '/admin/jobs',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminMediaVocabRoute = AppAdminMediaVocabRouteImport.update({
  id: '/admin/media-vocab',
  path: '/admin/media-vocab',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminUsageRoute = AppAdminUsageRouteImport.update({
  id: '/admin/usage',
  path: '/admin/usage',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => AppRoute,
} as any)
const AppApprovalsIndexRoute = AppApprovalsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppApprovalsRoute,
} as any)
const AppHotelsIndexRoute = AppHotelsIndexRouteImport.update({
  id: '/hotels/',
  path: '/hotels/',
  getParentRoute: () => AppRoute,
} as any)
const AppHotelsHotelIdRoute = AppHotelsHotelIdRouteImport.update({
  id: '/hotels/$hotelId',
  path: '/hotels/$hotelId',
  getParentRoute: () => AppRoute,
} as any)
const AppHotelsNewRoute = AppHotelsNewRouteImport.update({
  id: '/hotels/new',
  path: '/hotels/new',
  getParentRoute: () => AppRoute,
} as any)
const AppPlansIndexRoute = AppPlansIndexRouteImport.update({
  id: '/plans/',
  path: '/plans/',
  getParentRoute: () => AppRoute,
} as any)
const AppPlansNewRoute = AppPlansNewRouteImport.update({
  id: '/plans/new',
  path: '/plans/new',
  getParentRoute: () => AppRoute,
} as any)
const AppApprovalsBatchIdPreviewRoute =
  AppApprovalsBatchIdPreviewRouteImport.update({
    id: '/$batchId/preview',
    path: '/$batchId/preview',
    getParentRoute: () => AppApprovalsRoute,
  } as any)
const AppHotelsHotelIdIndexRoute = AppHotelsHotelIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppHotelsHotelIdRoute,
} as any)
const AppHotelsHotelIdActivityRoute =
  AppHotelsHotelIdActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AppHotelsHotelIdRoute,
  } as any)
const AppHotelsHotelIdArchiveRoute = AppHotelsHotelIdArchiveRouteImport.update({
  id: '/archive',
  path: '/archive',
  getParentRoute: () => AppHotelsHotelIdRoute,
} as any)
const AppHotelsHotelIdCalendarRoute =
  AppHotelsHotelIdCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => AppHotelsHotelIdRoute,
  } as any)
const AppHotelsHotelIdEventsRoute = AppHotelsHotelIdEventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => AppHotelsHotelIdRoute,
} as any)
const AppHotelsHotelIdMediaRoute = AppHotelsHotelIdMediaRouteImport.update({
  id: '/media',
  path: '/media',
  getParentRoute: () => AppHotelsHotelIdRoute,
} as any)
const AppHotelsHotelIdSettingsRoute =
  AppHotelsHotelIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AppHotelsHotelIdRoute,
  } as any)
const AppPlansHotelIdYearMonthRoute =
  AppPlansHotelIdYearMonthRouteImport.update({
    id: '/plans/$hotelId/$year/$month',
    path: '/plans/$hotelId/$year/$month',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/app/approvals': typeof AppApprovalsRouteWithChildren
  '/app/approved': typeof AppApprovedRoute
  '/app/content': typeof AppContentRoute
  '/app/inbox': typeof AppInboxRoute
  '/app/profile': typeof AppProfileRoute
  '/app/reserve': typeof AppReserveRoute
  '/approve/$token': typeof ApproveTokenRoute
  '/calendar/$token': typeof CalendarTokenRoute
  '/login/verify': typeof LoginVerifyRoute
  '/app/': typeof AppIndexRoute
  '/app/admin/ai': typeof AppAdminAiRoute
  '/app/admin/api-tokens': typeof AppAdminApiTokensRoute
  '/app/admin/emails': typeof AppAdminEmailsRoute
  '/app/admin/jobs': typeof AppAdminJobsRoute
  '/app/admin/media-vocab': typeof AppAdminMediaVocabRoute
  '/app/admin/usage': typeof AppAdminUsageRoute
  '/app/admin/users': typeof AppAdminUsersRoute
  '/app/hotels/$hotelId': typeof AppHotelsHotelIdRouteWithChildren
  '/app/hotels/new': typeof AppHotelsNewRoute
  '/app/plans/new': typeof AppPlansNewRoute
  '/app/approvals/': typeof AppApprovalsIndexRoute
  '/app/hotels/': typeof AppHotelsIndexRoute
  '/app/plans/': typeof AppPlansIndexRoute
  '/app/approvals/$batchId/preview': typeof AppApprovalsBatchIdPreviewRoute
  '/app/hotels/$hotelId/activity': typeof AppHotelsHotelIdActivityRoute
  '/app/hotels/$hotelId/archive': typeof AppHotelsHotelIdArchiveRoute
  '/app/hotels/$hotelId/calendar': typeof AppHotelsHotelIdCalendarRoute
  '/app/hotels/$hotelId/events': typeof AppHotelsHotelIdEventsRoute
  '/app/hotels/$hotelId/media': typeof AppHotelsHotelIdMediaRoute
  '/app/hotels/$hotelId/settings': typeof AppHotelsHotelIdSettingsRoute
  '/app/hotels/$hotelId/': typeof AppHotelsHotelIdIndexRoute
  '/app/plans/$hotelId/$year/$month': typeof AppPlansHotelIdYearMonthRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/app/approved': typeof AppApprovedRoute
  '/app/content': typeof AppContentRoute
  '/app/inbox': typeof AppInboxRoute
  '/app/profile': typeof AppProfileRoute
  '/app/reserve': typeof AppReserveRoute
  '/approve/$token': typeof ApproveTokenRoute
  '/calendar/$token': typeof CalendarTokenRoute
  '/login/verify': typeof LoginVerifyRoute
  '/app': typeof AppIndexRoute
  '/app/admin/ai': typeof AppAdminAiRoute
  '/app/admin/api-tokens': typeof AppAdminApiTokensRoute
  '/app/admin/emails': typeof AppAdminEmailsRoute
  '/app/admin/jobs': typeof AppAdminJobsRoute
  '/app/admin/media-vocab': typeof AppAdminMediaVocabRoute
  '/app/admin/usage': typeof AppAdminUsageRoute
  '/app/admin/users': typeof AppAdminUsersRoute
  '/app/hotels/new': typeof AppHotelsNewRoute
  '/app/plans/new': typeof AppPlansNewRoute
  '/app/approvals': typeof AppApprovalsIndexRoute
  '/app/hotels': typeof AppHotelsIndexRoute
  '/app/plans': typeof AppPlansIndexRoute
  '/app/approvals/$batchId/preview': typeof AppApprovalsBatchIdPreviewRoute
  '/app/hotels/$hotelId/activity': typeof AppHotelsHotelIdActivityRoute
  '/app/hotels/$hotelId/archive': typeof AppHotelsHotelIdArchiveRoute
  '/app/hotels/$hotelId/calendar': typeof AppHotelsHotelIdCalendarRoute
  '/app/hotels/$hotelId/events': typeof AppHotelsHotelIdEventsRoute
  '/app/hotels/$hotelId/media': typeof AppHotelsHotelIdMediaRoute
  '/app/hotels/$hotelId/settings': typeof AppHotelsHotelIdSettingsRoute
  '/app/hotels/$hotelId': typeof AppHotelsHotelIdIndexRoute
  '/app/plans/$hotelId/$year/$month': typeof AppPlansHotelIdYearMonthRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/app/approvals': typeof AppApprovalsRouteWithChildren
  '/app/approved': typeof AppApprovedRoute
  '/app/content': typeof AppContentRoute
  '/app/inbox': typeof AppInboxRoute
  '/app/profile': typeof AppProfileRoute
  '/app/reserve': typeof AppReserveRoute
  '/approve/$token': typeof ApproveTokenRoute
  '/calendar/$token': typeof CalendarTokenRoute
  '/login_/verify': typeof LoginVerifyRoute
  '/app/': typeof AppIndexRoute
  '/app/admin/ai': typeof AppAdminAiRoute
  '/app/admin/api-tokens': typeof AppAdminApiTokensRoute
  '/app/admin/emails': typeof AppAdminEmailsRoute
  '/app/admin/jobs': typeof AppAdminJobsRoute
  '/app/admin/media-vocab': typeof AppAdminMediaVocabRoute
  '/app/admin/usage': typeof AppAdminUsageRoute
  '/app/admin/users': typeof AppAdminUsersRoute
  '/app/hotels/$hotelId': typeof AppHotelsHotelIdRouteWithChildren
  '/app/hotels/new': typeof AppHotelsNewRoute
  '/app/plans/new': typeof AppPlansNewRoute
  '/app/approvals/': typeof AppApprovalsIndexRoute
  '/app/hotels/': typeof AppHotelsIndexRoute
  '/app/plans/': typeof AppPlansIndexRoute
  '/app/approvals/$batchId/preview': typeof AppApprovalsBatchIdPreviewRoute
  '/app/hotels/$hotelId/activity': typeof AppHotelsHotelIdActivityRoute
  '/app/hotels/$hotelId/archive': typeof AppHotelsHotelIdArchiveRoute
  '/app/hotels/$hotelId/calendar': typeof AppHotelsHotelIdCalendarRoute
  '/app/hotels/$hotelId/events': typeof AppHotelsHotelIdEventsRoute
  '/app/hotels/$hotelId/media': typeof AppHotelsHotelIdMediaRoute
  '/app/hotels/$hotelId/settings': typeof AppHotelsHotelIdSettingsRoute
  '/app/hotels/$hotelId/': typeof AppHotelsHotelIdIndexRoute
  '/app/plans/$hotelId/$year/$month': typeof AppPlansHotelIdYearMonthRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/login'
    | '/app/approvals'
    | '/app/approved'
    | '/app/content'
    | '/app/inbox'
    | '/app/profile'
    | '/app/reserve'
    | '/approve/$token'
    | '/calendar/$token'
    | '/login/verify'
    | '/app/'
    | '/app/admin/ai'
    | '/app/admin/api-tokens'
    | '/app/admin/emails'
    | '/app/admin/jobs'
    | '/app/admin/media-vocab'
    | '/app/admin/usage'
    | '/app/admin/users'
    | '/app/hotels/$hotelId'
    | '/app/hotels/new'
    | '/app/plans/new'
    | '/app/approvals/'
    | '/app/hotels/'
    | '/app/plans/'
    | '/app/approvals/$batchId/preview'
    | '/app/hotels/$hotelId/activity'
    | '/app/hotels/$hotelId/archive'
    | '/app/hotels/$hotelId/calendar'
    | '/app/hotels/$hotelId/events'
    | '/app/hotels/$hotelId/media'
    | '/app/hotels/$hotelId/settings'
    | '/app/hotels/$hotelId/'
    | '/app/plans/$hotelId/$year/$month'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/app/approved'
    | '/app/content'
    | '/app/inbox'
    | '/app/profile'
    | '/app/reserve'
    | '/approve/$token'
    | '/calendar/$token'
    | '/login/verify'
    | '/app'
    | '/app/admin/ai'
    | '/app/admin/api-tokens'
    | '/app/admin/emails'
    | '/app/admin/jobs'
    | '/app/admin/media-vocab'
    | '/app/admin/usage'
    | '/app/admin/users'
    | '/app/hotels/new'
    | '/app/plans/new'
    | '/app/approvals'
    | '/app/hotels'
    | '/app/plans'
    | '/app/approvals/$batchId/preview'
    | '/app/hotels/$hotelId/activity'
    | '/app/hotels/$hotelId/archive'
    | '/app/hotels/$hotelId/calendar'
    | '/app/hotels/$hotelId/events'
    | '/app/hotels/$hotelId/media'
    | '/app/hotels/$hotelId/settings'
    | '/app/hotels/$hotelId'
    | '/app/plans/$hotelId/$year/$month'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/login'
    | '/app/approvals'
    | '/app/approved'
    | '/app/content'
    | '/app/inbox'
    | '/app/profile'
    | '/app/reserve'
    | '/approve/$token'
    | '/calendar/$token'
    | '/login_/verify'
    | '/app/'
    | '/app/admin/ai'
    | '/app/admin/api-tokens'
    | '/app/admin/emails'
    | '/app/admin/jobs'
    | '/app/admin/media-vocab'
    | '/app/admin/usage'
    | '/app/admin/users'
    | '/app/hotels/$hotelId'
    | '/app/hotels/new'
    | '/app/plans/new'
    | '/app/approvals/'
    | '/app/hotels/'
    | '/app/plans/'
    | '/app/approvals/$batchId/preview'
    | '/app/hotels/$hotelId/activity'
    | '/app/hotels/$hotelId/archive'
    | '/app/hotels/$hotelId/calendar'
    | '/app/hotels/$hotelId/events'
    | '/app/hotels/$hotelId/media'
    | '/app/hotels/$hotelId/settings'
    | '/app/hotels/$hotelId/'
    | '/app/plans/$hotelId/$year/$month'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  ApproveTokenRoute: typeof ApproveTokenRoute
  CalendarTokenRoute: typeof CalendarTokenRoute
  LoginVerifyRoute: typeof LoginVerifyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/approvals': {
      id: '/app/approvals'
      path: '/approvals'
      fullPath: '/app/approvals'
      preLoaderRoute: typeof AppApprovalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/approved': {
      id: '/app/approved'
      path: '/approved'
      fullPath: '/app/approved'
      preLoaderRoute: typeof AppApprovedRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/content': {
      id: '/app/content'
      path: '/content'
      fullPath: '/app/content'
      preLoaderRoute: typeof AppContentRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/inbox': {
      id: '/app/inbox'
      path: '/inbox'
      fullPath: '/app/inbox'
      preLoaderRoute: typeof AppInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/profile': {
      id: '/app/profile'
      path: '/profile'
      fullPath: '/app/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/reserve': {
      id: '/app/reserve'
      path: '/reserve'
      fullPath: '/app/reserve'
      preLoaderRoute: typeof AppReserveRouteImport
      parentRoute: typeof AppRoute
    }
    '/approve/$token': {
      id: '/approve/$token'
      path: '/approve/$token'
      fullPath: '/approve/$token'
      preLoaderRoute: typeof ApproveTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar/$token': {
      id: '/calendar/$token'
      path: '/calendar/$token'
      fullPath: '/calendar/$token'
      preLoaderRoute: typeof CalendarTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login_/verify': {
      id: '/login_/verify'
      path: '/login/verify'
      fullPath: '/login/verify'
      preLoaderRoute: typeof LoginVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/admin/ai': {
      id: '/app/admin/ai'
      path: '/admin/ai'
      fullPath: '/app/admin/ai'
      preLoaderRoute: typeof AppAdminAiRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin/api-tokens': {
      id: '/app/admin/api-tokens'
      path: '/admin/api-tokens'
      fullPath: '/app/admin/api-tokens'
      preLoaderRoute: typeof AppAdminApiTokensRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin/emails': {
      id: '/app/admin/emails'
      path: '/admin/emails'
      fullPath: '/app/admin/emails'
      preLoaderRoute: typeof AppAdminEmailsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin/jobs': {
      id: '/app/admin/jobs'
      path: '/admin/jobs'
      fullPath: '/app/admin/jobs'
      preLoaderRoute: typeof AppAdminJobsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin/media-vocab': {
      id: '/app/admin/media-vocab'
      path: '/admin/media-vocab'
      fullPath: '/app/admin/media-vocab'
      preLoaderRoute: typeof AppAdminMediaVocabRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin/usage': {
      id: '/app/admin/usage'
      path: '/admin/usage'
      fullPath: '/app/admin/usage'
      preLoaderRoute: typeof AppAdminUsageRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin/users': {
      id: '/app/admin/users'
      path: '/admin/users'
      fullPath: '/app/admin/users'
      preLoaderRoute: typeof AppAdminUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/approvals/': {
      id: '/app/approvals/'
      path: '/'
      fullPath: '/app/approvals/'
      preLoaderRoute: typeof AppApprovalsIndexRouteImport
      parentRoute: typeof AppApprovalsRoute
    }
    '/app/hotels/': {
      id: '/app/hotels/'
      path: '/hotels'
      fullPath: '/app/hotels/'
      preLoaderRoute: typeof AppHotelsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/hotels/$hotelId': {
      id: '/app/hotels/$hotelId'
      path: '/hotels/$hotelId'
      fullPath: '/app/hotels/$hotelId'
      preLoaderRoute: typeof AppHotelsHotelIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/hotels/new': {
      id: '/app/hotels/new'
      path: '/hotels/new'
      fullPath: '/app/hotels/new'
      preLoaderRoute: typeof AppHotelsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/plans/': {
      id: '/app/plans/'
      path: '/plans'
      fullPath: '/app/plans/'
      preLoaderRoute: typeof AppPlansIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/plans/new': {
      id: '/app/plans/new'
      path: '/plans/new'
      fullPath: '/app/plans/new'
      preLoaderRoute: typeof AppPlansNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/approvals/$batchId/preview': {
      id: '/app/approvals/$batchId/preview'
      path: '/$batchId/preview'
      fullPath: '/app/approvals/$batchId/preview'
      preLoaderRoute: typeof AppApprovalsBatchIdPreviewRouteImport
      parentRoute: typeof AppApprovalsRoute
    }
    '/app/hotels/$hotelId/': {
      id: '/app/hotels/$hotelId/'
      path: '/'
      fullPath: '/app/hotels/$hotelId/'
      preLoaderRoute: typeof AppHotelsHotelIdIndexRouteImport
      parentRoute: typeof AppHotelsHotelIdRoute
    }
    '/app/hotels/$hotelId/activity': {
      id: '/app/hotels/$hotelId/activity'
      path: '/activity'
      fullPath: '/app/hotels/$hotelId/activity'
      preLoaderRoute: typeof AppHotelsHotelIdActivityRouteImport
      parentRoute: typeof AppHotelsHotelIdRoute
    }
    '/app/hotels/$hotelId/archive': {
      id: '/app/hotels/$hotelId/archive'
      path: '/archive'
      fullPath: '/app/hotels/$hotelId/archive'
      preLoaderRoute: typeof AppHotelsHotelIdArchiveRouteImport
      parentRoute: typeof AppHotelsHotelIdRoute
    }
    '/app/hotels/$hotelId/calendar': {
      id: '/app/hotels/$hotelId/calendar'
      path: '/calendar'
      fullPath: '/app/hotels/$hotelId/calendar'
      preLoaderRoute: typeof AppHotelsHotelIdCalendarRouteImport
      parentRoute: typeof AppHotelsHotelIdRoute
    }
    '/app/hotels/$hotelId/events': {
      id: '/app/hotels/$hotelId/events'
      path: '/events'
      fullPath: '/app/hotels/$hotelId/events'
      preLoaderRoute: typeof AppHotelsHotelIdEventsRouteImport
      parentRoute: typeof AppHotelsHotelIdRoute
    }
    '/app/hotels/$hotelId/media': {
      id: '/app/hotels/$hotelId/media'
      path: '/media'
      fullPath: '/app/hotels/$hotelId/media'
      preLoaderRoute: typeof AppHotelsHotelIdMediaRouteImport
      parentRoute: typeof AppHotelsHotelIdRoute
    }
    '/app/hotels/$hotelId/settings': {
      id: '/app/hotels/$hotelId/settings'
      path: '/settings'
      fullPath: '/app/hotels/$hotelId/settings'
      preLoaderRoute: typeof AppHotelsHotelIdSettingsRouteImport
      parentRoute: typeof AppHotelsHotelIdRoute
    }
    '/app/plans/$hotelId/$year/$month': {
      id: '/app/plans/$hotelId/$year/$month'
      path: '/plans/$hotelId/$year/$month'
      fullPath: '/app/plans/$hotelId/$year/$month'
      preLoaderRoute: typeof AppPlansHotelIdYearMonthRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppApprovalsRouteChildren {
  AppApprovalsIndexRoute: typeof AppApprovalsIndexRoute
  AppApprovalsBatchIdPreviewRoute: typeof AppApprovalsBatchIdPreviewRoute
}

const AppApprovalsRouteChildren: AppApprovalsRouteChildren = {
  AppApprovalsIndexRoute: AppApprovalsIndexRoute,
  AppApprovalsBatchIdPreviewRoute: AppApprovalsBatchIdPreviewRoute,
}

const AppApprovalsRouteWithChildren = AppApprovalsRoute._addFileChildren(
  AppApprovalsRouteChildren,
)

interface AppHotelsHotelIdRouteChildren {
  AppHotelsHotelIdActivityRoute: typeof AppHotelsHotelIdActivityRoute
  AppHotelsHotelIdArchiveRoute: typeof AppHotelsHotelIdArchiveRoute
  AppHotelsHotelIdCalendarRoute: typeof AppHotelsHotelIdCalendarRoute
  AppHotelsHotelIdEventsRoute: typeof AppHotelsHotelIdEventsRoute
  AppHotelsHotelIdMediaRoute: typeof AppHotelsHotelIdMediaRoute
  AppHotelsHotelIdSettingsRoute: typeof AppHotelsHotelIdSettingsRoute
  AppHotelsHotelIdIndexRoute: typeof AppHotelsHotelIdIndexRoute
}

const AppHotelsHotelIdRouteChildren: AppHotelsHotelIdRouteChildren = {
  AppHotelsHotelIdActivityRoute: AppHotelsHotelIdActivityRoute,
  AppHotelsHotelIdArchiveRoute: AppHotelsHotelIdArchiveRoute,
  AppHotelsHotelIdCalendarRoute: AppHotelsHotelIdCalendarRoute,
  AppHotelsHotelIdEventsRoute: AppHotelsHotelIdEventsRoute,
  AppHotelsHotelIdMediaRoute: AppHotelsHotelIdMediaRoute,
  AppHotelsHotelIdSettingsRoute: AppHotelsHotelIdSettingsRoute,
  AppHotelsHotelIdIndexRoute: AppHotelsHotelIdIndexRoute,
}

const AppHotelsHotelIdRouteWithChildren =
  AppHotelsHotelIdRoute._addFileChildren(AppHotelsHotelIdRouteChildren)

interface AppRouteChildren {
  AppApprovalsRoute: typeof AppApprovalsRouteWithChildren
  AppApprovedRoute: typeof AppApprovedRoute
  AppContentRoute: typeof AppContentRoute
  AppInboxRoute: typeof AppInboxRoute
  AppProfileRoute: typeof AppProfileRoute
  AppReserveRoute: typeof AppReserveRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAdminAiRoute: typeof AppAdminAiRoute
  AppAdminApiTokensRoute: typeof AppAdminApiTokensRoute
  AppAdminEmailsRoute: typeof AppAdminEmailsRoute
  AppAdminJobsRoute: typeof AppAdminJobsRoute
  AppAdminMediaVocabRoute: typeof AppAdminMediaVocabRoute
  AppAdminUsageRoute: typeof AppAdminUsageRoute
  AppAdminUsersRoute: typeof AppAdminUsersRoute
  AppHotelsHotelIdRoute: typeof AppHotelsHotelIdRouteWithChildren
  AppHotelsNewRoute: typeof AppHotelsNewRoute
  AppPlansNewRoute: typeof AppPlansNewRoute
  AppHotelsIndexRoute: typeof AppHotelsIndexRoute
  AppPlansIndexRoute: typeof AppPlansIndexRoute
  AppPlansHotelIdYearMonthRoute: typeof AppPlansHotelIdYearMonthRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppApprovalsRoute: AppApprovalsRouteWithChildren,
  AppApprovedRoute: AppApprovedRoute,
  AppContentRoute: AppContentRoute,
  AppInboxRoute: AppInboxRoute,
  AppProfileRoute: AppProfileRoute,
  AppReserveRoute: AppReserveRoute,
  AppIndexRoute: AppIndexRoute,
  AppAdminAiRoute: AppAdminAiRoute,
  AppAdminApiTokensRoute: AppAdminApiTokensRoute,
  AppAdminEmailsRoute: AppAdminEmailsRoute,
  AppAdminJobsRoute: AppAdminJobsRoute,
  AppAdminMediaVocabRoute: AppAdminMediaVocabRoute,
  AppAdminUsageRoute: AppAdminUsageRoute,
  AppAdminUsersRoute: AppAdminUsersRoute,
  AppHotelsHotelIdRoute: AppHotelsHotelIdRouteWithChildren,
  AppHotelsNewRoute: AppHotelsNewRoute,
  AppPlansNewRoute: AppPlansNewRoute,
  AppHotelsIndexRoute: AppHotelsIndexRoute,
  AppPlansIndexRoute: AppPlansIndexRoute,
  AppPlansHotelIdYearMonthRoute: AppPlansHotelIdYearMonthRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  ApproveTokenRoute: ApproveTokenRoute,
  CalendarTokenRoute: CalendarTokenRoute,
  LoginVerifyRoute: LoginVerifyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
